import axiosInstance from '../config/axios.js';

const API_BASE = '/roles';

const roleService = {
  // Get all roles
  getAll: async () => {
    const response = await axiosInstance.get(API_BASE);
    return response.data;
  },

  // Get role by ID
  getById: async (roleId) => {
    const response = await axiosInstance.get(`${API_BASE}/${roleId}`);
    return response.data;
  },

  // Create new role
  create: async (roleData) => {
    const response = await axiosInstance.post(API_BASE, roleData);
    return response.data;
  },

  // Update role
  update: async (roleId, roleData) => {
    const response = await axiosInstance.put(`${API_BASE}/${roleId}`, roleData);
    return response.data;
  },

  // Delete role
  delete: async (roleId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${roleId}`);
    return response.data;
  }
};

export default roleService;